module.exports = __webpack_public_path__ + "static/media/brain-dump-1.a92f10b4.svg";